import { useMutation } from '@tanstack/vue-query'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async ({ name, subject, message }: { name: string; subject: string; message: string }) =>
      await $fetch<string>(`/api/user/${authStore.user!.id}/help`, {
        method: 'POST',
        body: JSON.stringify({ name, subject, message }),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: () => {},
  })
}
